import React from "react";
import { LottieLoading } from "@ospweb/sdk-ui";
import { cn } from "utils";

const CardLoading: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center min-h-[306px] h-full",
        className,
      )}
    >
      <LottieLoading style={{ width: 40, height: 40 }} />
    </div>
  );
};

export default CardLoading;
